import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center" }
const _hoisted_2 = { class: "flex flex-col items-center w-[30rem] mt-5" }
const _hoisted_3 = { class: "w-[30rem] font-[700]" }
const _hoisted_4 = {
  key: 0,
  class: "text-v_red text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "text-v_green text-center"
}
const _hoisted_6 = {
  key: 2,
  class: "text-v_red text-center"
}

import { recoveryPassword } from "@/repositories/recoveryPassword"
import {
	Button,
	H1,
	H2,
	InputContainer,
	LoginInput,
	LoginButton,
	IconContainer,
} from "../atoms"
import { ref } from "vue"
import { useHead } from "@vueuse/head"


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  props: {
	forgotPassword: {
		type: Boolean,
		required: true,
	},
},
  emits: ["showLoading"],
  setup(__props, { emit }) {

useHead({ title: "Comissão Revenda - Redefinir senha" })

let username = ref("")
let showButton = ref(false)
let validationError = ref(false)
let sucess = ref(false)





const checkEmptyFields = () => {
	validationError.value = false
	sucess.value = false

	if (username.value != "") {
		showButton.value = true
	} else {
		showButton.value = false
	}
}

const resetPassword = async () => {
	emit("showLoading", true)
	const res: any = await recoveryPassword(username.value)

	if (res?.status == 204) {
		sucess.value = true
	} else {
		validationError.value = true
	}
	emit("showLoading", false)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(H1), { class: "text-v_dark_blue" }, {
        default: _withCtx(() => [
          _createTextVNode("Redefinir senha")
        ]),
        _: 1
      }),
      _createVNode(_unref(H2), { class: "text-v_dark_gray mt-5" }, {
        default: _withCtx(() => [
          _createTextVNode(" Digite o email cadastrado para enviarmos o link de redefinição. ")
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(InputContainer), { h: "8rem" }, {
      default: _withCtx(() => [
        _createVNode(_unref(LoginInput), {
          type: "text",
          modelValue: _unref(username),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(username) ? (username).value = $event : username = $event)),
          placeholder: "Username",
          validationError: _unref(validationError),
          class: _normalizeClass(!_unref(validationError) || (_unref(sucess) && 'mt-[-0.72rem]')),
          onKeyup: checkEmptyFields
        }, null, 8, ["modelValue", "validationError", "class"]),
        _createVNode(_unref(IconContainer), { top: "3.2rem" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { icon: "mdi-account" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_unref(validationError))
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Username incorreto. Tente novamente! "))
        : _createCommentVNode("", true),
      (_unref(sucess))
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Você receberá um email para redefinição de senha "))
        : _createCommentVNode("", true),
      (__props.forgotPassword)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Parece que você esqueceu a sua senha, informe o username e receba um link para redefinição "))
        : _createCommentVNode("", true),
      _createVNode(_unref(LoginButton), {
        disabled: !_unref(showButton),
        enableButton: _unref(showButton),
        class: "mt-8 mb-2 active:scale-90",
        onClick: resetPassword
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Enviar ")
        ]),
        _: 1
      }, 8, ["disabled", "enableButton"]),
      _createVNode(_unref(Button), {
        w: "30rem",
        h: "4.75rem",
        bd: "#CFD1E1",
        class: "active:scale-90",
        color: "#09092A",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('backToLogin', false)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Voltar ")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})